"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPositionRanges = getPositionRanges;
exports.getPositionRange = getPositionRange;
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
const index_js_1 = require("../../index.js");
const coins_js_1 = require("../../common/coins.js");
async function getPositionRanges(poolNames = []) {
    const res = new Map();
    // Use Promise.all to handle multiple promises in parallel
    await Promise.all(poolNames.map(async (poolName) => {
        if (poolName == "ALPHA" ||
            !["CETUS", "BLUEFIN"].includes(index_js_1.poolInfo[poolName.toString()].parentProtocolName)) {
            return;
        }
        let investor;
        if (index_js_1.poolInfo[poolName.toString()].parentProtocolName == "CETUS") {
            investor = (await (0, index_js_1.getInvestor)(poolName, false));
        }
        else {
            investor = (await (0, index_js_1.getInvestor)(poolName, false));
        }
        const coinAName = index_js_1.doubleAssetPoolCoinMap[poolName].coin1;
        const coinA = coins_js_1.coinsList[coinAName];
        const coinBName = index_js_1.doubleAssetPoolCoinMap[poolName].coin2;
        const coinB = coins_js_1.coinsList[coinBName];
        if (investor) {
            const upperBound = 443636;
            let lowerTick = Number(investor.content.fields.lower_tick);
            let upperTick = Number(investor.content.fields.upper_tick);
            if (lowerTick > upperBound) {
                lowerTick = -~(lowerTick - 1);
            }
            if (upperTick > upperBound) {
                upperTick = -~(upperTick - 1);
            }
            const lowerPrice = cetus_sui_clmm_sdk_1.TickMath.tickIndexToPrice(lowerTick, coinA.expo, coinB.expo);
            const upperPrice = cetus_sui_clmm_sdk_1.TickMath.tickIndexToPrice(upperTick, coinA.expo, coinB.expo);
            res.set(poolName, {
                lowerPrice: lowerPrice.toString(),
                upperPrice: upperPrice.toString(),
            });
        }
    }));
    return res;
}
async function getPositionRange(ignoreCache) {
    const res = new Map();
    for (const poolNameString of Object.keys(index_js_1.poolInfo)) {
        const poolName = poolNameString;
        if (poolName == "ALPHA" ||
            !["CETUS", "BLUEFIN"].includes(index_js_1.poolInfo[poolNameString].parentProtocolName)) {
            continue;
        }
        let investor;
        if (index_js_1.poolInfo[poolNameString].parentProtocolName == "CETUS") {
            investor = (await (0, index_js_1.getInvestor)(poolName, ignoreCache));
        }
        else {
            investor = (await (0, index_js_1.getInvestor)(poolName, ignoreCache));
        }
        const coinAName = index_js_1.doubleAssetPoolCoinMap[poolName].coin1;
        const coinA = coins_js_1.coinsList[coinAName];
        const coinBName = index_js_1.doubleAssetPoolCoinMap[poolName].coin2;
        const coinB = coins_js_1.coinsList[coinBName];
        if (investor) {
            const upperBound = 443636;
            let lowerTick = Number(investor.content.fields.lower_tick);
            let upperTick = Number(investor.content.fields.upper_tick);
            if (lowerTick > upperBound) {
                lowerTick = -~(lowerTick - 1);
            }
            if (upperTick > upperBound) {
                upperTick = -~(upperTick - 1);
            }
            const lowerPrice = cetus_sui_clmm_sdk_1.TickMath.tickIndexToPrice(lowerTick, coinA.expo, coinB.expo);
            const upperPrice = cetus_sui_clmm_sdk_1.TickMath.tickIndexToPrice(upperTick, coinA.expo, coinB.expo);
            res.set(poolName, {
                lowerPrice: lowerPrice.toString(),
                upperPrice: upperPrice.toString(),
            });
        }
    }
    return res;
}
//# sourceMappingURL=getPositionRange.js.map